<script>
    export let home_team;
    export let away_team;
    export let game_time;
    // Best price per market from fantasy/game_lines.card_lines:
    // {away: {spread, total, ml}, home: {...}, books} with each cell {text, odds, book, link} or null
    export let lines = null;
    game_time = new Date(game_time);
    const rows = () => [["away", away_team], ["home", home_team]];
    function cellOf(side, kind) {
        return lines && lines[side] ? lines[side][kind] : null;
    }
</script>
<style>
    .team-row { display: grid; grid-template-columns: minmax(0, 1fr) repeat(3, 3.6rem); align-items: center; gap: .25rem; }
    .team-row.no-lines { grid-template-columns: 1fr; }
    .team-name { display: flex; align-items: center; min-width: 0; }
    .team-name img { width: 2.2rem; height: 2.2rem; object-fit: contain; aspect-ratio: 1/1; }
    .team-name .nm { font-size: 1.25rem; font-weight: 500; margin-left: .25rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .odds-cell { display: flex; flex-direction: column; justify-content: center; min-height: 2.35rem; border: 1px solid #dee2e6; border-radius: .35rem; padding: .15rem .1rem; line-height: 1.15; text-align: center; text-decoration: none; color: #212529; background: #fff; font-size: .72rem; }
    .odds-cell:hover { border-color: #0d6efd; color: #0d6efd; background: #f3f7ff; }
    .odds-cell .pt { font-weight: 600; white-space: nowrap; }
    .odds-cell .px { color: #146c43; font-family: var(--bs-font-monospace); white-space: nowrap; }
    .odds-cell.empty { color: #adb5bd; border-style: dashed; }
    .hdr { display: grid; grid-template-columns: minmax(0, 1fr) repeat(3, 3.6rem); gap: .25rem; font-size: .6rem; text-transform: uppercase; letter-spacing: .04em; color: #6c757d; margin-bottom: .1rem; }
    .hdr span { text-align: center; }
    .foot { font-size: .62rem; color: #6c757d; margin-top: .2rem; text-align: right; }
    .shop-link { color: #0d6efd; text-decoration: none; font-weight: 600; }
    .shop-link:hover { text-decoration: underline; }
</style>
<div class="card mb-4 p-2 text-start">
    {#if lines}
    <div class="hdr"><span></span><span>Spread</span><span>Total</span><span>ML</span></div>
    {/if}
    {#each rows() as [side, team]}
    <div class="team-row {lines ? '' : 'no-lines'} mb-1">
        <div class="team-name">
            <img loading="lazy" src="{team.logo}" alt="{team.short_name} logo">
            <span class="nm">{team.short_name}</span>
        </div>
        {#if lines}
        {#each ["spread", "total", "ml"] as kind}
            {#if cellOf(side, kind)}
                {#if cellOf(side, kind).link}
                <a class="odds-cell" href={cellOf(side, kind).link} target="_blank" rel="nofollow noopener" title="Bet at {cellOf(side, kind).book}">
                    {#if kind !== "ml"}<div class="pt">{cellOf(side, kind).text}</div>{/if}
                    <div class="px">{cellOf(side, kind).odds}</div>
                </a>
                {:else}
                <span class="odds-cell" title="{cellOf(side, kind).book}">
                    {#if kind !== "ml"}<div class="pt">{cellOf(side, kind).text}</div>{/if}
                    <div class="px">{cellOf(side, kind).odds}</div>
                </span>
                {/if}
            {:else}
                <span class="odds-cell empty">&ndash;</span>
            {/if}
        {/each}
        {/if}
    </div>
    {/each}
    {#if lines}
    <div class="foot">Best of {lines.books} books &middot; tap to bet{#if lines.url} &middot; <a href={lines.url} class="shop-link">Shop this game &rarr;</a>{/if}</div>
    {/if}
</div>
